import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <BrowserRouter basename="/application">
      <App />
    </BrowserRouter>
);
